import gql from 'graphql-tag';
import {
  disposisiFragment
} from './disposisi';
import {
  STATUS_ACCEPT,
  STATUS_CONCEPT,
  STATUS_ARCHIVE,
  STATUS_DRAFT,
  STATUS_TRASH,
  STATUS_SEND
} from '../const/surat';

const detailFragment = gql `
  fragment detailFragment on Surat {
    id
    uuid
    index
    perihal
    isi_ringkas
    keterangan
    lampiran
    status
    created_at
    updated_at
    tipe
    tanggal
    pengguna {
      id
      nama
      jabatan {
        id
        nama
      }
    }
    kategori_surat {
      id
      nama
    }
    sifat_surat {
      id
      nama
    }
    kode_surat {
      id
      nama
      kode_surat
    }
    dokumen {
      id
      uuid
      nama
      lokasi
      besar_dokumen
      jenis_dokumen
      file_url
      tipe
      attribute
    }
    disposisi {
      ...disposisiFragment
    }
    kecepatan_surat {
      id
      nama
      keterangan
    }
    nomor_surat {
      id
      nomor
      kode_surat
    }
    surat_masuk{
      id
      pengirim
      uuid
      tipe
    }
    surat_keluar{
      id
      uuid
      tujuan
      tte_pengguna{
        id
        nama
      }
      pengirim_id
      pengirim{
        id
        nama
        jabatan{
          id
          nama
        }
      }
      status_kirim_manual
      status_kirim_email
    }
    tujuan{
      id
      uuid
      nama
      email
    }
    disposisi_terakhir_pengguna_id
  }
  ${disposisiFragment}
`;

const suratFragment = gql `
  fragment suratFragment on Surat {
    id
    uuid
    index
    status
    tipe
    kode_surat {
      id
      nama
      kode_surat
    }
    surat_masuk{
      id
      pengirim
      tipe
    }

    surat_keluar{
      id
      uuid
      tujuan
      tte_pengguna{
       nama
      }
    }

    tanggal

    nomor_surat {
      id
      nomor
    }
    perihal
    tujuan{
      id
      nama
    }
  }
`;

const GET_ALL = gql `
  query Surat(
    $perPage: Int!
    $page: Int
    $orderBy: [SuratOrderByOrderByClause!]
    $where: SuratWhereWhereConditions
  ) {
    surat(first: $perPage, page: $page, orderBy: $orderBy, where: $where) {
      data {
        ...suratFragment
      }
      paginatorInfo {
        count
        total
        hasMorePages
        currentPage
        lastPage
      }
    }
  }
  ${suratFragment}
`;

const GET_COUNT = gql `
  query Surat(
    $perPage: Int!
    $page: Int
    $orderBy: [SuratOrderByOrderByClause!]
    $where: SuratWhereWhereConditions
  ) {
    surat(first: $perPage, page: $page, orderBy: $orderBy, where: $where) {
      paginatorInfo {
        count
        total
      }
    }
  }
`;

const GET_ALL_FILTER = gql `
  query Surat($perPage: Int!, $page: Int, $filter: SuratFilterArgs,$orderBy: [SuratFilterOrderByOrderByClause!], $where: SuratFilterWhereWhereConditions) {
    surat: suratFilter(first: $perPage, page: $page, filter: $filter, where: $where, orderBy: $orderBy) {
      data {
        ...suratFragment
      }
      paginatorInfo {
        count
        total
        hasMorePages
        currentPage
        lastPage
      }
    }
  }
  ${suratFragment}
`;

const GET_ALL_SURAT_KELUAR_FILTER = gql `
  query suratKeluarFilter($perPage: Int!, $page: Int, $filter: SuratKeluarFilterArgs,$orderBy: [SuratKeluarFilterOrderByOrderByClause!], $where: SuratKeluarFilterWhereWhereConditions) {
    suratKeluarFilter(first: $perPage, page: $page, filter: $filter, where: $where, orderBy: $orderBy) {
      data {
        ...suratFragment
      }
      paginatorInfo {
        count
        total
        hasMorePages
        currentPage
        lastPage
      }
    }
  }
  ${suratFragment}
`;

// const GET_ALL_SURAT_KELUAR_FILTER = gql `
//   query suratKeluarFilter($perPage: Int!, $page: Int, $filter: SuratKeluarFilterArgs,$orderBy: [SuratKeluarFilterOrderByOrderByClause!], $where: SuratKeluarFilterWhereWhereConditions) {
//     suratKeluarFilter(first: $perPage, page: $page, filter: $filter, where: $where, orderBy: $orderBy) {
//       data {
//         ...suratFragment
//       }
//       paginatorInfo {
//         count
//         total
//         hasMorePages
//         currentPage
//         lastPage
//       }
//     }
//   }
//   ${suratFragment}
// `;

const GET_ONE = gql `
  query getOne($id: ID!) {
    suratById(id: $id) {
      ...detailFragment
    }
  }
  ${detailFragment}
`;

const GET_BY_UUID = gql `
  query getByUuid($uuid: String) {
    surat: suratByUuid(uuid: $uuid) {
      ...detailFragment
    }
  }
  ${detailFragment}
`;

const CREATE = gql `
  mutation($input: SuratCreateInput!) {
    suratCreate(input: $input) {
      ...suratFragment
    }
  }
  ${suratFragment}
`;

const UPDATE = gql `
  mutation($id: ID!, $input: SuratUpdateInput!) {
    suratUpdate(id: $id, input: $input) {
      id
    }
  }
`;

const GET_FIELD_SELECTION = gql `
  query Selection($perPage: Int!) {
    kategoriSurat(first: $perPage, orderBy: [{ field: NAMA, order: ASC }]) {
      data {
        id
        nama
      }
    }
    kodeSurat(
      first: $perPage
      orderBy: [{ field: KODE_SURAT, order: ASC }, { field: NAMA, order: ASC }]
    ) {
      data {
        id
        kode_surat
        nama
      }
    }
    sifatSurat(first: $perPage, orderBy: [{ field: NAMA, order: ASC }]) {
      data {
        id
        nama
      }
    }
    # Temporary solution
    pengguna: penggunaGetByPositionName(
      positionName: "Kepala Dinas"
      first: $perPage
      orderBy: [{ field: NAMA, order: ASC }]
    ) {
      data {
        id
        nama
      }
    }
    kecepatanSurat(first: 5) {
      data {
        id
        nama
        keterangan
      }
    }
  }
`;

const filters = {
  SURAT_MASUK: () => ({
    orderBy: [{
      field: 'TANGGAL',
      order: 'DESC'
    }],
    where: {
      AND: [{
          column: 'TIPE',
          value: 'surat_masuk'
        },
        // {
        //   column: 'STATUS',
        //   operator: 'EQ',
        //   value: STATUS_ARCHIVE
        // },
        // { column: 'PENGGUNA_ID', value: userId },
      ],
    },
  }),
  SURAT_KELUAR: () => ({
    orderBy: [{
      field: 'TANGGAL',
      order: 'DESC'
    }],
    where: {
      AND: [{
          column: 'TIPE',
          value: 'surat_keluar'
        },
        // {
        //   column: 'STATUS',
        //   operator: 'EQ',
        //   value: STATUS_ARCHIVE
        // },
        // { column: 'PENGGUNA_ID', value: userId },
      ],
    },
  }),
  TERKIRIM: () => ({
    orderBy: [{
      field: 'TANGGAL',
      order: 'DESC'
    }],
    where: {
      AND: [{
          column: 'TIPE',
          value: 'surat_keluar'
        },
        {
          column: 'STATUS',
          operator: 'EQ',
          value: STATUS_SEND
        },
      ],
    },
  }),
  KONSEP: (userId) => ({
    orderBy: [{
      field: 'TANGGAL',
      order: 'DESC'
    }],
    where: {
      AND: [{
          column: 'STATUS',
          value: STATUS_CONCEPT
        },
        {
          column: 'PENGGUNA_ID',
          value: userId
        },
      ],
    },
  }),
  DRAFT: (userId) => ({
    orderBy: [{
      field: 'TANGGAL',
      order: 'DESC'
    }],
    where: {
      AND: [{
          column: 'STATUS',
          value: STATUS_DRAFT
        },
        {
          column: 'DISPOSISI_TERAKHIR_PENGGUNA_ID',
          value: userId
        },
      ],
    },
  }),
  DISPOSISI: (userId) => ({
    orderBy: [{
      field: 'TANGGAL',
      order: 'DESC'
    }],
    where: {
      AND: [{
          column: 'STATUS',
          operator: 'IN',
          value: [STATUS_DRAFT, STATUS_ACCEPT],
        },
        {
          column: 'DISPOSISI_TERAKHIR_PENGGUNA_ID',
          value: userId
        },
      ],
    },
  }),
  ARSIP: () => ({
    orderBy: [{
      field: 'TANGGAL',
      order: 'DESC'
    }],
    where: {
      AND: [{
        column: 'STATUS',
        value: STATUS_ARCHIVE
      }],
    },
  }),
  SAMPAH: (userId) => ({
    orderBy: [{
      field: 'TANGGAL',
      order: 'DESC'
    }],
    where: {
      AND: [{
          column: 'STATUS',
          value: STATUS_TRASH
        },
        {
          column: 'PENGGUNA_ID',
          value: userId
        },
      ],
    },
  }),
};

const pagination = {
  perPage: 10,
  defaultPage: 1,
};

export {
  suratFragment,
  detailFragment,
  GET_ALL,
  GET_COUNT,
  GET_ALL_FILTER,
  GET_ALL_SURAT_KELUAR_FILTER,
  GET_ONE,
  GET_BY_UUID,
  CREATE,
  UPDATE,
  GET_FIELD_SELECTION,
  filters,
  pagination
};
